import axios from 'axios'
import $ from 'jquery'
import Qs from 'qs'
import React, { Component } from 'react'
import { Link, useLocation } from 'react-router-dom'
import Select from 'react-select'

const equal = require('deep-equal')
const slugify = require('slugify')

export default class TileFilter extends Component {
  constructor(props) {
    super(props)

    this.state = {
      posts: 'Loading...',
      currentToggle: props.currentToggle,
      currentClass: '',
      lastQuery: '',
      currentSelected: props.currentSelected || null,
      maxNumPages: 0,
      page: parseInt(((props.match || {}).params || {}).page || 1),
      extraClass: props.extraClass || '',
      extraTilesClass: props.extraTilesClass || '',
      useRouter: props.useRouter || false
    }

    this.query = this.query.bind(this)
    this.makeCurrentQuery = this.makeCurrentQuery.bind(this)
    this.setFoundPosts = this.setFoundPosts.bind(this)
    this.setToggle = this.setToggle.bind(this)
    this.setSelected = this.setSelected.bind(this)
    this.makeTaxQuery = this.makeTaxQuery.bind(this)
    this.setPage = this.setPage.bind(this)
    this.reset = this.reset.bind(this)
  }

  

  componentDidMount() {
    this.query()
  }

  componentWillReceiveProps(newProps) {
    const { location } = this.props;
    const { useRouter, page, currentToggle } = this.state
    const { toggleGroup } = this.props
    if (useRouter) {
      let newCategory = ((newProps.match || {}).params || {}).category || 'All'

      const newPage = parseInt(((newProps.match || {}).params || {}).page || 1)

      if (newCategory !== 'All') {
        newCategory = Object.keys(toggleGroup).filter(
          key => slugify(key).toLowerCase() === newCategory
        )[0]
      }

      if (newCategory !== currentToggle) {
        this.setToggle(newCategory)
        $('html, body').animate({
          scrollTop: $('.tile-filter-wrapper').offset().top
        })
      } else if (newPage !== page) {
        this.setPage(newPage)
        $('html, body').animate({
          scrollTop: $('.tile-filter-wrapper').offset().top
        })
      }
    }
  }

  makeTaxQuery() {
    const { currentToggle, currentSelected } = this.state
    const { toggleGroup, selectGroup, base_query } = this.props
    const tax_query =
      'tax_query' in base_query
        ? { tax_query: [base_query.tax_query[0]] }
        : { tax_query: [] }

    if (toggleGroup[currentToggle]) {
      for (let i = 0; i < toggleGroup[currentToggle].tax_query.length; i++) {
        tax_query.tax_query.push(toggleGroup[currentToggle].tax_query[i])
      }
    }

    if (currentSelected && currentSelected.value !== '') {
      tax_query.tax_query.push(currentSelected.query)
    }

    // Object.assign(tax_query.tax_query, selectGroup[currentSelected])
    // const tax_query = Object.assign({}, toggleGroup[currentToggle])
    // consttax_query.tax_query.relation = 'AND'

    tax_query.tax_query = tax_query.tax_query.filter(
      x => typeof x !== 'undefined'
    )
    if (tax_query.tax_query.length > 1) {
      tax_query.tax_query.relation = 'AND'
    }

    return tax_query
  }

  makeCurrentQuery() {
    const { page } = this.state
    const { base_query, action } = this.props
    this.makeTaxQuery()

    const query = Object.assign({}, base_query, this.makeTaxQuery(), {
      paged: page
    })

    return Object.assign({}, { action }, { query })
  }

  setFoundPosts(found) {
    this.setState(
      {
        posts: found.data.html,
        currentClass: '',
        maxNumPages: found.data.max_num_pages
      },
      () => {
        if (!!window.skrollr) {
          window.skrollr.refresh()
        }
      }
    )
  }

  setToggle(name) {
    console.log(name)
    const { currentToggle } = this.state
    // Navigate to page 1
    this.setState({ currentToggle: name, page: 1 }, this.query)
  }

  setSelected(obj) {
    console.log(obj)
    this.setState({ currentSelected: obj, page: 1 }, this.query)
  }

  setPage(n) {
    this.setState({ page: n }, this.query)
  }

  reset() {
    this.setState(
      {
        currentToggle: this.props.currentToggle,
        currentSelected: this.props.currentSelected
      },
      this.query
    )
  }

  query() {
    const { lastQuery } = this.state
    const { ajaxurl } = this.props
    const data = this.makeCurrentQuery()

    if (!equal(data, lastQuery)) {
      this.setState({ currentClass: 'loading', lastQuery: data })

      axios
        .post(ajaxurl, Qs.stringify(data))
        .then(this.setFoundPosts)
        .catch(function(error) {
          console.log(error)
        })
    }
  }

  render() {
    const {
      title,
      toggleGroup,
      selectGroup,
      selectGroupPlaceholderText,
      hide_title,
      hidePagination,
      hideReset
    } = this.props

    const {
      posts,
      currentToggle,
      currentClass,
      currentSelected,
      maxNumPages,
      page,
      extraClass,
      extraTilesClass,
      useRouter
    } = this.state

    // hide filter bar on "focus area" taxonomy pages
    const shouldHideFilterBar = location.pathname.includes("/focus-area/");

    return (
      <div className={`tile-filter ${currentClass} ${extraClass}`}>
        <div
          className={`tile-filter__header ${
            shouldHideFilterBar ? "no-filter-bar" : ""
          }`}
        >
          <div className="container">
            {hide_title !== "1" && title !== "" ? <h2>{title}</h2> : ""}
            {
              /* should we hide filter bar? */
              !shouldHideFilterBar && (
                <>
                  <div className="mobile-filter-bar-title">Filter</div>
                  <div className="filter-bar">
                    <div className="filter-bar__inner">
                      {Object.keys(toggleGroup).length ? (
                        <div className="toggle-group">
                          {console.log(toggleGroup)}
                          <span
                            className="filter"
                            style={{
                              marginRight:
                                location.pathname === "/work/" ? 0 : "",
                            }}
                          >
                            Filter:{" "}
                          </span>
                          {!location.pathname === "/work/" &&
                            Object.keys(toggleGroup).map((toggle) => {
                              return !useRouter ? (
                                <button
                                  key={toggle}
                                  className={`theme-btn ${
                                    toggle === currentToggle ? "active" : ""
                                  }`}
                                  onClick={() => {
                                    if (currentClass !== "loading") {
                                      this.setToggle(toggle);
                                    }
                                  }}
                                >
                                  {toggle}
                                </button>
                              ) : (
                                <Link
                                  key={toggle}
                                  className={
                                    toggle === currentToggle ? "active" : ""
                                  }
                                  to={`${
                                    toggle === "All"
                                      ? ""
                                      : `/${slugify(toggle).toLowerCase()}/1`
                                  }`}
                                >
                                  {toggle}
                                </Link>
                              );
                            })}
                        </div>
                      ) : (
                        ""
                      )}
                      <div
                        className="right-group"
                        style={{
                          marginLeft: location.pathname === "/work/" ? 0 : "",
                        }}
                      >
                        {selectGroup && selectGroup.length ? (
                          <Select
                            options={selectGroup}
                            value={currentSelected}
                            onChange={this.setSelected}
                            className="custom-react-select"
                            placeholder={this.props.selectGroupPlaceholderText}
                          />
                        ) : (
                          ""
                        )}
                        {!(hideReset === "1") ? (
                          <button
                            onClick={this.reset}
                            className="reset"
                            style={
                              selectGroup && selectGroup.length
                                ? {}
                                : { marginLeft: "auto" }
                            }
                          >
                            <img
                              src={`${this.props.theme_folder_url}/src/images/reset-x.svg`}
                              alt="Remove all filters"
                            />
                            Reset
                          </button>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                </>
              )
            }
          </div>
        </div>
        <div
          className={`tile-filter__found-posts tiles ${
            extraTilesClass ? extraTilesClass : 'large'
          }`}
        >
          <div
            className="container"
            dangerouslySetInnerHTML={{ __html: posts }}
          />
        </div>
        {!(hidePagination === '1' || maxNumPages === 1 || !maxNumPages) ? (
          <div className="pagination">
            <ul>
              {Array(maxNumPages)
                .fill(0)
                .map((x, i) => {
                  // Make sure I add the correct link
                  // if useRouter is true then I'll add the router link
                  //
                  return (
                    <li
                      key={`page-${i + 1}`}
                      className={`${page === i + 1 ? 'current' : ''}`}
                    >
                      {useRouter ? (
                        <Link
                          to={`${
                            currentToggle === 'All'
                              ? ''
                              : `/${slugify(currentToggle).toLowerCase()}`
                          }${i === 0 ? `/` : `/${i + 1}/`}`}
                          className={page === i + 1 ? 'disabled' : ''}
                        >
                          {i + 1}
                        </Link>
                      ) : (
                        <button
                          disabled={page === i + 1}
                          onClick={() => {
                            this.setPage(i + 1)
                            $('html, body').animate({
                              scrollTop: $('.tile-filter-wrapper').offset().top
                            })
                          }}
                        >
                          {i + 1}
                        </button>
                      )}
                    </li>
                  )
                })}
            </ul>
          </div>
        ) : (
          ''
        )}
      </div>
    )
  }
}
